import mutations from "./mutations"
import actions from "./actions"
import getters from "./getters"
export default {
    namespaced:true ,
    state(){
        return{
            catchReceipts : [],
            catchReceiptsLoaded:false,
            deleting:false,
            postCatch:false
 
        }
    },
    mutations,
    getters,
    actions,
}
